import { client } from './client'
import type { Project, CreateProjectRequest, CreateProjectResponse, UpdateProjectRequest, UpdateProjectResponse, Technology, ProjectTeamMember, ProjectPhase, PaginationParams, PagedResult, ProjectFilters } from '@/types'

export const projectsApi = {
  getAll: (params?: Partial<PaginationParams> & ProjectFilters) =>
    client.get<PagedResult<Project>>('/projects', { params }).then(r => r.data),

  getClients: () =>
    client.get<string[]>('/projects/clients').then(r => r.data),

  getById: (projectId: string) =>
    client.get<Project>(`/projects/${projectId}`).then(r => r.data),

  create: (data: CreateProjectRequest) =>
    client.post<CreateProjectResponse>('/projects', data).then(r => r.data),

  delete: (projectId: string) =>
    client.delete(`/projects/${projectId}`).then(r => r.data),

  decommission: (projectId: string) =>
    client.delete(`/projects/${projectId}/decommission`).then(r => r.data),

  update: (projectId: string, data: UpdateProjectRequest) =>
    client.put<UpdateProjectResponse>(`/projects/${projectId}`, data).then(r => r.data),

  getTechnologies: () =>
    client.get<Technology[]>('/technologies').then(r => r.data),

  getTeamMembers: (projectId: string) =>
    client.get<ProjectTeamMember[]>(`/projects/${projectId}/team-members`).then(r => r.data),

  getProjectPhases: (projectId: string) =>
    client.get<ProjectPhase[]>(`/projects/${projectId}/project-phases`).then(r => r.data),
}
